import { Record } from 'immutable';
import { isEmpty } from 'lodash';
import config from 'commons-vehicle/config/index.js';

const imagesServer = config.source.image;
const imagesBasePath = '/images';
const imageInventoryPath = '/inventory';

function buildImageUrls(imagePath) {
    return {
        url: `${imagesServer}${imagePath || ''}`,
        url360x270: `${imagesServer}/ir/w360h270${imagePath || ''}`,
        url360x240: `${imagesServer}/ir/w360h197c${imagePath || ''}`,
        url440: `${imagesServer}/ir/w440${imagePath || ''}`,
    };
}

function buildInventoryBasePath() {
    return `${imagesBasePath}${imageInventoryPath}`;
}

const AccessoriesAndOptionRecordV25 = Record({
    category: '',
    dataTypeId: 0,
    typeId: 0,
    supplier: '',
    code: '',
    description: '',
    photo: '',
    includedItems: '',
    isAvailable: false,
    isIncludedInOtherItem: false,
    isSelected: false,
    isMandatory: false,
    isDueAtDelivery: false,
    inclusionIsLocked: false,
    retail: 0,
    totalRetail: 0,
    payment: 0,
    totalPayment: 0,
});

class InventoryAccessoriesAndOptionModelV25 extends AccessoriesAndOptionRecordV25 {
    constructor(args) {
        super({ ...args });
    }

    getMainImage() {
        return this?.mainPicture?.url || '';
    }

    getMainImage360x270() {
        return this?.mainPicture?.url360x270 || '';
    }

    getMainImage440() {
        return this?.mainPicture?.url440 || '';
    }

    getCatalogSideImage() {
        return this.catalog && this.catalog.side && this.catalog.side.url ? this.catalog.side.url : '';
    }

    getCatalogSideImage360x197() {
        return this.catalog && this.catalog.side && this.catalog.side.url360x240 ? this.catalog.side.url360x240 : '';
    }

    hasPictures() {
        return !isEmpty(this.pictures);
    }

    getPicture(index) {
        // eslint-disable-next-line no-restricted-globals
        if (!isFinite(index) || index < 0 || !this.pictures.length || index > this.pictures.length) {
            return '';
        }

        const picture = this.pictures[index];

        return picture || '';
    }

    hasVideo() {
        return !!this?.video?.video;
    }

    getVideo() {
        return this.hasVideo() ? this.video.video : '';
    }

    hasAudio() {
        return !!this?.audio?.audio;
    }

    getAudio() {
        return this.hasAudio() ? this.audio.audio : '';
    }
}

export { buildImageUrls, buildInventoryBasePath, imagesServer, imagesBasePath, imageInventoryPath };

export default InventoryAccessoriesAndOptionModelV25;
